import { create } from 'zustand';

const initialState = {
    isSet: false,
    itemsOnPage: 25,
    totalCount: 0,
    currentPage: 1,
    isWaiting: false,
    isFinished: false,
    singers: null
  }

const songbookStore = create((set, get) => ({

}));

export default songbookStore;